import moment from "moment";

// Export the data for the example tables
export const exampleTablesData = {
    fondFacts: {
        title: 'Fondfakta',
        rows : [
            { values: ['Fondförmögenhet', '1 000 000 SEK'] },
            { values: ['Fondstart', '2017-01-01'] },
            { values: ['Förvaltningsavgift', '1.5%'] },
            { values: ['Risknivå', '4'] },
            { values: ['Fondtyp', 'Aktiefond'] },
            { values: ['Fondförmögenhet', '1 000 000 SEK'] },
            { values: ['Fondstart', '2017-01-01'] },
            { values: ['Förvaltningsavgift', '1.5%'] },
            { values: ['Risknivå', '4'] },
            { values: ['Fondtyp', 'Aktiefond'] }
        ]
    },
    largestBranches: {
        title: 'Största branscher (aktier)',
        subTitle: moment().format('YYYY-MM-DD'),
        headings: ['AKTIESEKTORER', '%'],
        rows: [
            { values: ['Industri', '50,29'], icon: 'branch-industry' },
            { values: ['Finans', '21,04'], icon: 'branch-finance' },
            { values: ['Konsument Stabil', '7,57'], icon: 'branch-consumer-stable' },
            { values: ['Sjukvård', '7,12'], icon: 'branch-health' },
            { values: ['Fastigheter', '6,17'], icon: 'branch-real-estate'}
        ]
    },
    largestHoldings: {
        title: 'Största innehav',
        subTitle: moment().format('YYYY-MM-DD'),
        headings: ['INNEHAV', 'BRANCH (AKT)', '%'],
        rows: [
            { values: ['Apple Inc', 'Teknik', '5,29'], icon: 'circle-plus' },
            { values: ['Microsoft Corp', 'Teknik', '4,04'], icon: 'circle-plus' },
            { values: ['Amazon.com Inc', 'Teknik', '3,57'], icon: 'circle-plus' },
            { values: ['Facebook Inc', 'Teknik', '3,12'], icon: 'circle-minus' },
            { values: ['Alphabet Inc', 'Teknik', '2,17'], icon: 'circle-plus' }
        ]
    },
    returns: {
        title: 'Avkastning % (SEK)',
        subTitle: moment().format('YYYY-MM-DD'),
        headings: ['', 'FOND', 'KATEG.', 'INDEX'],
        rows: [
            { values: ['Hittills i år', '6,75', '6,75', '8,36'] },
            { values: ['3 år medel', '6,75', '6,75', '8,36'] },
            { values: ['5 år medel', '6,75', '6,75', '8,36'] },
            { values: ['10 år annualiserat', '6,75', '6,75', '8,36'] },
        ]
    },
    charges: {
        title: 'Avgifter',
        subTitle: moment().format('YYYY-MM-DD'),
        rows: [
            { values: ['Förvaltningsavgift', '1,20%'] },
            { values: ['KID avgift övriga kostnader', '1,20%'] },
            { values: ['Resultatbaserad avgift %', ''] },
        ]
    }
};